import { Typography, Checkbox, Box } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

import Style from './style';

import { CourseFiltersKey, CourseFilterObjectItemProps, CourseAPIQueryProps } from 'src/interfaces/course';

const filterItemShowBeforeReadMoreCount = 4;

type Props = {
  object: CourseFilterObjectItemProps;
  index: number;
  isShowMore: boolean;
  filterKey: CourseFiltersKey;
  handleFilters: (e: React.ChangeEvent<HTMLInputElement>, key: CourseFiltersKey) => void;
  queryFilters?: CourseAPIQueryProps;
};

const CourseFilterCheckbox = ({ object, isShowMore, index, filterKey, handleFilters, queryFilters }: Props) => {
  let checked = false;
  const queryFilter: any = queryFilters![filterKey];

  if (queryFilter) {
    checked = queryFilter.includes(filterKey === CourseFiltersKey.CERTIFICATE ? `${`${object.value}`}` : object.value);
  }

  const isPreviewElement = () => {
    if (isShowMore) return false;
    return index === filterItemShowBeforeReadMoreCount;
  };

  return (
    <Style>
      <FormControlLabel
        sx={{ fontFamily: 'Lanna', display: 'table' }}
        control={
          <Box sx={{ display: 'table-cell' }}>
            <Checkbox disabled={isPreviewElement()} checked={checked} size="small" value={object.value} />
          </Box>
        }
        label={
          <Typography className="name" variant="h4" component="span" sx={{ fontFamily: 'Lanna', fontSize: '18px' }}>
            {object.name}
          </Typography>
        }
        onChange={(e) => handleFilters(e as React.ChangeEvent<HTMLInputElement>, filterKey)}
      />
      {isPreviewElement() && <Box className="overlay" />}
    </Style>
  );
};

export default CourseFilterCheckbox;
